import * as React from 'react';
import { prefixCls } from '../../utils';
import './FieldUi.less';
import { jsx as _jsx } from "react/jsx-runtime";

/** 滚动到错误用到了这个class */
export const errorClassName = `${prefixCls}-error-message`;
export const FieldError = props => {
  const {
    error
  } = props;

  if (!error) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", {
    className: errorClassName,
    children: error
  });
};
//# sourceMappingURL=es/Other/Field/FieldError.js.map